import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyukkinboListGetReq,
  TSyukkinboListGetRes,
  TSyukkinboGetReq,
  TZikanSyuseiPutReq,
  TZikanSyuseiGetReq,
  TZikanSyuseiGetRes,
  TZikanSyuseiListPutReq,
  TZyomuinSyukkinboDigitachoGetReq,
  TZyomuinSyukkinboDigitachoRes,
  TZyomuinSyukkinboSummaryGetRes,
  TSyukkinboSummaryGetRes,
  TSyukkinboDakokuGetRes,
} from "./TSyukkinbo"

/**
 * 出勤簿に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class SyukkinboService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyukkinboListGetReq} params
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TSyukkinboListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyukkinboListGetRes[]>> =
        await this.getInner(`/attendance/syukkinbo`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 出勤簿 取得
   *
   * @param {TSyukkinboGetReq} params
   * @param {(param: TApiResponse<TSyukkinboIndividualGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboIndividualGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getIndividualList = async (params: TSyukkinboGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyukkinboListGetRes>> =
        await this.getInner(
          `/attendance/syukkinbo/actions/getindividuallist`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 検索取得
   *
   * @param {TSyukkinboListGetReq} params
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  zyomuinGetList = async (params: TSyukkinboListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyukkinboListGetRes[]>> =
        await this.getInner(`/attendance/zyomuinsyukkinbo`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 出勤簿集計 取得
   *
   * @param {TSyukkinboGetReq} params
   * @param {(param: TApiResponse<TSyukkinboSummaryGetRes>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboSummaryGetRes>) => any} reject
   * @memberof MenuService
   */
  getSummaryList = async (params: TSyukkinboGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyukkinboSummaryGetRes>> =
        await this.getInner(
          `/attendance/syukkinbo/actions/getmonthsummary`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 乗務員出勤簿集計 取得
   *
   * @param {TSyukkinboGetReq} params
   * @param {(param: TApiResponse<TZyomuinSyukkinboSummaryGetRes>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinSyukkinboSummaryGetRes>) => any} reject
   * @memberof MenuService
   */
  zyomuinGetSummaryList = async (params: TSyukkinboGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinSyukkinboSummaryGetRes>> =
        await this.getInner(
          `/attendance/zyomuinsyukkinbo/actions/getmonthsummary`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 出勤簿 取得
   *
   * @param {TSyukkinboGetReq} params
   * @param {(param: TApiResponse<TSyukkinboIndividualGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboIndividualGetRes[]>) => any} reject
   * @memberof MenuService
   */
  zyomuinGetIndividualList = async (params: TSyukkinboGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyukkinboListGetRes>> =
        await this.getInner(
          `/attendance/zyomuinsyukkinbo/actions/getindividuallist`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 打刻リスト取得
   *
   * @param {TSyukkinboListGetReq} params
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyukkinboListGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getDakokuList = async (params: TSyukkinboListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyukkinboDakokuGetRes[]>> =
        await this.getInner(
          `/attendance/syukkinbo/actions/getdakokulist`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * デジタコ情報取得
   *
   * @param {TSyukkinboGetReq} params
   * @param {(param: TApiResponse<TZyomuinSyukkinboDigitachoRes[]>) => any} resolve
   * @param {(param: TApiResponse<TZyomuinSyukkinboDigitachoRes[]>) => any} reject
   * @memberof MenuService
   */
  getDigiTachoList = async (params: TZyomuinSyukkinboDigitachoGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyomuinSyukkinboDigitachoRes[]>> =
        await this.getInner(
          `/attendance/zyomuinsyukkinbo/actions/getdigitacho`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 時間修正 取得
   *
   * @param {TZikanSyuseiGetReq} params
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} resolve
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} reject
   * @memberof MenuService
   */
  getZikanSyusei = async (params: TZikanSyuseiGetReq) => {
    try {
      // const res: AxiosResponse<TApiResponse<TSyukkinboInfoGetRes[]>> =
      // await this.getInner(`/attendance/syukkinbo`, params)
      //return res.data
      //   if (params.年月 === "2" && params.品コード === "1") {
      //     // eslint-disable-next-line no-throw-literal
      //     throw "ERROR"
      //   }

      return {
        data: dummyZikanSyuseiData,
      }
      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TZikanSyuseiPutReq} data
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZikanSyuseiGetRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (id: string, date: string, data: TZikanSyuseiPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `attendance/syukkinbo/${id}/${date}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 単体削除
   *
   * @param {TZikanSyuseiPutReq} data
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZikanSyuseiGetRes>>) => any} reject
   * @memberof KyotenService
   */
  delete = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `attendance/syukkinbo/actions/delete/${id}`,
        id
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * リスト更新
   *
   * @param {TZikanSyuseiPutReq} data
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZikanSyuseiGetRes>>) => any} reject
   * @memberof KyotenService
   */
  putList = async (data: TZikanSyuseiListPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `attendance/syukkinbo/upsertlist`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * リスト更新
   *
   * @param {TZikanSyuseiPutReq} data
   * @param {(param: TApiResponse<TZikanSyuseiGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TZikanSyuseiGetRes>>) => any} reject
   * @memberof KyotenService
   */
  zyomuinPutList = async (data: TZikanSyuseiListPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `attendance/zyomuinsyukkinbo/upsertlist`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  //   /**
  //    * 単体取得
  //    *
  //    * @param {TMenuInfoGetReq} params
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
  //    * @memberof MenuService
  //    */
  //   get = async (id: string | number) => {
  //     try {
  //       // const res: AxiosResponse<TApiResponse<TSyukkinboInfoGetRes[]>> =
  //       // await this.getInner(`/master/hinmei`, params)
  //       //return res.data
  //       if (id === "3") {
  //         // eslint-disable-next-line no-throw-literal
  //         throw "ERROR"
  //       }

  //       return {
  //         data: dummyData[0],
  //       }
  //       //TODO: api実装必要
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体登録
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   post = async (data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
  //         `master/hinmei/`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体更新
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   put = async (id: string, data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
  //         `master/hinmei/${id}`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }
}

// TODO:安全管理 ⇒ サーバー側で分類見て1入れてもらう?
// 10	事務員
// 20	運行部員
// 30	乗務員
// 31	契約乗務員(65歳以上）

const dummyZikanSyuseiData: TZikanSyuseiGetRes = {
  社員番号: "0001",
  氏名: "てすとたろう",
  日付: "2022-02-01T00:00:00",
  勤務区分コード: "10",
  出勤時間: "2022-02-01T09:00:00",
  退勤時間: "2022-02-01T18:00:00",
  出庫時間: "2022-02-01T10:00:00",
  入庫時間: "2022-02-01T17:00:00",
  拘束時間: 9,
  労働時間: 8,
  待機時間: 0,
  残業時間: 0,
  深夜残業: 0,
  休日労働: 0,
  休憩時間: 1,
  休息時間: 0,
  備考: "てすと",
}
